import React, { useState, useEffect } from 'react';
import HelpCard from './HelpCard';
import helpJson from './helpInfo.json';

const HelpMenu = ({ pathName }) => {
  // Track selected card id and type
  const [selectedCard, setSelectedCard] = useState({ id: null, type: null });
  // Use a flat help info structure for universal mapping
  const componentName = pathName.split('/')[1];
  const formFields = helpJson?.[componentName]?.['form-fields'];

  useEffect(() => {
    // Event delegation for all elements with data-help-id
    const showHelpForElement = (element, eventType) => {
      const helpId = element.getAttribute('data-help-id');
      const tagType = element.tagName;
      if (helpId) {
        setSelectedCard({ id: helpId, type: eventType === 'focus' ? tagType : 'LABEL' });
        const cardElement = document.querySelector(`[card-id="${helpId}"]`);
        // const labelElement = document.querySelectorAll("label");

        if (cardElement) {
          cardElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          cardElement.style.transition = 'background-color 0.5s ease';
          cardElement.classList.add('highlight-border');
          setTimeout(() => {
            cardElement.classList.remove('highlight-border');
          }, 2000);
        }
      }
    };

    const handleFocus = (event) => {
      event.stopPropagation();
      showHelpForElement(event.target, 'focus');
    };

    const handleBlur = (event) => {
      const helpId = event.target.getAttribute('data-help-id');
      if (helpId) {
        setSelectedCard({ id: helpId, type: '' });
      }
    };

    const handleLabelClick = (event) => {
      if (event.target.tagName === 'LABEL') {
        event.preventDefault(); // Prevent default label click behavior
        let associatedElement = event.target.control;
        if (!associatedElement) {
          // Try by 'for' attribute
          const htmlFor = event.target.getAttribute('for');
          if (htmlFor) {
            associatedElement = document.getElementById(htmlFor);
          }
        }
        if (!associatedElement) {
          // Try to find input/select/textarea inside the label
          associatedElement = event.target.querySelector('input, select, textarea');
        }
        if (associatedElement && associatedElement.hasAttribute('data-help-id')) {
          showHelpForElement(associatedElement, 'click');
        } else {
          showHelpForElement(event.target, 'click');
        }
      }
    };

    document.addEventListener('focusin', handleFocus);
    document.addEventListener('focusout', handleBlur);
    document.addEventListener('click', handleLabelClick);

    // Cleanup
    return () => {
      document.removeEventListener('focusin', handleFocus);
      document.removeEventListener('focusout', handleBlur);
      document.removeEventListener('click', handleLabelClick);
    };
  }, [pathName]);

  return (
    <div className='helpMenu' style={{
         position: "fixed",
         right: "15px",
         top: "134px",
         height: "80vh",
         overflow: "scroll",
         scrollbarWidth: "none",
         border: "transparent",
         zIndex: 999,
         transition: "right 0.9s cubic-bezier(0.4, 0, 0.2, 1)", 
         boxShadow: "0 2px 16px rgba(0,0,0,0.12)",
         background:"var(--se-background-alternative) !important"
    }}>
        { formFields && Object.keys(formFields)?.length ? (
          Object.keys(formFields).map((fieldKey) => {
            const field = formFields[fieldKey];
            return (
              <HelpCard
                id={fieldKey}
                key={fieldKey}
                title={field.title}
                description={field.description}
                placeholder={field.placeholder}
                type={selectedCard.id === fieldKey ? selectedCard.type : undefined}
              />
            );
          })
        ) : (
          <span className="d-flex justify-content-center">
            {" "}
            {"No Content Found"}
          </span>
        )}
   
      
    </div>
  )
}

export default HelpMenu